import { TimePart } from '../../infrastructure/time-part';

export class SerieSettingEntity {

    public static fromDto(dto: any): SerieSettingEntity {
        if (!dto) {
            return new SerieSettingEntity();
        }
        const entity = new SerieSettingEntity();

        entity.id = dto.id;
        entity.scheduleId = dto.scheduleId;
        entity.periods = dto.periods;
        entity.fields = dto.fields;
        entity.gameCount = dto.gameCount;
        entity.periodLength = dto.periodLength;
        entity.periodPause = dto.periodPause;
        entity.gamePause = dto.gamePause;
        entity.startTime = new TimePart(dto.startTime);
        entity.concurrency = dto.concurrency;
        return entity;
    }

    public static fromDtoArray(dtoArray: any[]): SerieSettingEntity[] {
        const entities: SerieSettingEntity[] = [];
        if (!dtoArray) {
            return entities;
        }
        for (const dto of dtoArray) {
            const entity = SerieSettingEntity.fromDto(dto);
            entities.push(entity);
        }
        return entities;
    }

    public static toDtoArray(entityArray: SerieSettingEntity[]): any[] {
        const dtos: any[] = [];
        for (const entity of entityArray) {
            dtos.push(entity.toDto());
        }
        return dtos;
    }

    public id: string = null;
    public scheduleId: string = null;
    public periods: number = 2;
    public fields: number = 2;
    public gameCount: number = 3;
    public periodLength: number = 15;
    public periodPause: number = 5;
    public gamePause: number = 5;
    public startTime: TimePart = new TimePart('10:00');
    public concurrency: string;

    public toDto(): any {
        return {
            id: this.id,
            scheduleId: this.scheduleId,
            periods: this.periods,
            fields: this.fields,
            gameCount: this.gameCount,
            periodLength: this.periodLength,
            periodPause: this.periodPause,
            gamePause: this.gamePause,
            startTime: this.startTime.toISOString(),
            concurrency: this.concurrency
        };
    }
}
